var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.baseContainerClasses,on:{"mouseenter":_vm.onEnter,"mouseleave":_vm.onLeave,"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._t("default",null,{"hover":_vm.hover,"color":_vm.currentColor})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }